export const insightsColors = {
  blue: '#2B78C6',
  teal: '#14A4A4',
  lightBlue: '#A5CDF5',
  skyBlue: '#75B9FF',
  darkGray: '#8F939B',
  purple: '#972396',
  aqua40: '#4E98E3',
}
